import { createFileRoute } from '@tanstack/react-router'

import { checkinQuery } from '../lib/queries'
import { Checkin } from '../screens/Checkin'

export const Route = createFileRoute('/checkin')({
  validateSearch: (
    search: Record<string, unknown>,
  ): { type: 'weekly' | 'monthly'; question: number } => ({
    type: search.type === 'monthly' ? 'monthly' : 'weekly',
    question: Number.isFinite(Number(search.question)) ? Math.max(0, Number(search.question)) : 0,
  }),
  loaderDeps: ({ search }) => ({ type: search.type }),
  loader: ({ context, deps }) => context.queryClient.ensureQueryData(checkinQuery(deps.type)),
  component: Checkin,
})
